import { DeleteOutlined } from '@ant-design/icons';
import { message, Modal } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '../../methods/redux/hooks';
import { deleteCommercialBank } from '../../methods/redux/reducers/commercialBank';

const DeleteSection = styled.div`
	display: inline-flex;
	margin-left: 8px;

	& .deleteIcon {
		font-size: 20px;
		color: red;
		cursor: pointer;
	}
`;
interface IDeleteCommercialBank {
	id: string;
	setRefresh: Function;
}
const DeleteCommercialBank: FC<IDeleteCommercialBank> = ({
	id,
	setRefresh,
}) => {
	const dispatch = useAppDispatch();

	const deleteBank = async () => {
		try {
			const res = await dispatch(deleteCommercialBank(id));
			if (res) {
				setRefresh(Math.random());
			}
		} catch (error: any) {
			message.error(error?.message);
		}
	};

	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to remove this commercial bank?',
			onOk() {
				deleteBank();
			},
		});
	};
	return (
		<DeleteSection>
			<DeleteOutlined className="deleteIcon" onClick={confirm} />
		</DeleteSection>
	);
};

export default DeleteCommercialBank;
